import React, { Component } from 'react';
import './App.css';
import { observer, inject } from 'mobx-react';

import { Layout, Spin } from 'antd';
import { withRouter } from 'react-router-dom';

import ContentRouter from './ContentRouter';

import { api } from '../../services';
import { CheckingAuthentication } from 'air-checking-authentication';
import K from '../../constants';
import { storageHelper } from '../../helpers';

//NOTE: I added @withRouter decorator because --> https://github.com/mobxjs/mobx-react/issues/210

@withRouter
@inject('translationsStore', 'authStore', 'commonStore', 'noticesStore', 'carsStore', 'lockbeatStore')
@observer
class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false
    };
  }

  loadCurrentUser = () =>
    api('currentUser').then(user => {
      this.props.authStore.setUser(user);
    });

  afterTokenLoadings = () => {
    const { noticesStore, authStore, commonStore, lockbeatStore } = this.props;

    api('currentUser').then(user => {
      authStore.setUser(user);
    });
    api('dealer profile').then(dealer => {
      commonStore.setDealer(dealer);
    });

    if (authStore.isServiceManager) {
      api('serviceManager profile').then(serviceManager => {
        commonStore.setProfile(serviceManager);
      });
    }

    if (!authStore.isServiceManager) {
      noticesStore.loadNoticesVirtual({ page: 1 });
      this.noticesInterval = setInterval(() => {
        if (!noticesStore.carouselVisible) {
          noticesStore.loadNoticesVirtual({ page: 1 });
        }
      }, 30000);
    
      lockbeatStore.loadImei();
    }

    storageHelper.pruneReverseAddresses();
    this.noticesInterval = setInterval(() => {
      storageHelper.pruneReverseAddresses();
    }, 5 * 60 * 1000);
  };

  componentDidMount = () => {
    const { translationsStore, commonStore } = this.props;
    this.setState({ loading: true });
    this.loadCurrentUser();
    commonStore.setLoadingMessage(translationsStore.translate('spin.loading'));

    if (this.props.idToken) {
      this.props.authStore.setToken(this.props.idToken);
      console.log('componentDidMount: new token has been set');
      this.afterTokenLoadings();
    }
  };

  componentDidUpdate(prevProps) {
    if (this.props.idToken !== prevProps.idToken) {
      this.props.authStore.setToken(this.props.idToken);
      console.log('componentDidUpdate: new token has been set');
      if (!prevProps.idToken) {
        this.afterTokenLoadings();
      }
    }
    if (this.props.isauthenticated !== prevProps.isauthenticated) {
      this.props.authStore.setIsLoggedIn(this.props.isauthenticated);
    }
  }

  componentWillUnmount = () => {
    clearInterval(this.noticesInterval);
  };

  render() {
    const { commonStore } = this.props;
    return (
      <Layout style={{ minHeight: '100%' }} className="App">
        <Spin tip={commonStore.loadingMessage} spinning={commonStore.loading} size="large">
          {this.props.authStore.token && <ContentRouter />}
        </Spin>
      </Layout>
    );
  }
}

export default CheckingAuthentication({ region: K.AWS_AUTH_REGION, userPoolId: K.AWS_AUTH_USER_POOL_ID, userPoolWebClientId: K.AWS_AUTH_USER_POOL_WEBCLIENT_ID })(App);



// WEBPACK FOOTER //
// ./src/components/App/App.js